import {
  Box,
  Center,
  HStack,
  Icon,
  Input,
  Stack,
  Text,
} from '@chakra-ui/react';
import { Paste } from '@cronos-app/icons';
import { useTranslations } from 'next-intl';
import { useCallback } from 'react';

export const AddressInput = ({
  address,
  onChange,
  errorTip,
}: {
  address: string;
  onChange: (address: string) => void;
  errorTip?: string;
}) => {
  const t = useTranslations();
  const onPaste = useCallback(
    () =>
      navigator.clipboard.readText().then((text) => {
        text && onChange(text);
      }),
    [onChange],
  );
  return (
    <>
      <Box>
        <HStack
          h="64px"
          bg="gradients.dark-blue"
          px="4"
          border="1px solid"
          borderColor={errorTip ? 'brand.error' : 'brand.gray-scale-border-20'}
          rounded="8px"
          justifyContent="center"
          gap={1}
        >
          <Stack flex="1" gap="0">
            {!!address && (
              <Text textStyle="caption" color="brand.gray-scale-light-grey">
                {t('card.Crypto-com wallet address')}
              </Text>
            )}
            <Input
              autoFocus={false}
              h="24px"
              type="email"
              min="0"
              placeholder={t('card.Crypto-com wallet address')}
              onChange={(e) => onChange(e.target.value)}
              value={address}
              color={errorTip ? 'brand.error' : 'brand.white'}
              p="0"
              border="none"
              outline="none"
              boxShadow="none"
              bg="none"
              _focus={{
                outline: 'none',
                boxShadow: 'none',
                border: 'none',
                bg: 'none',
              }}
              _placeholder={{
                color: 'brand.gray-scale-light-grey',
              }}
            />
          </Stack>
          <Center cursor="pointer" boxSize="8" onClick={onPaste}>
            <Icon as={Paste} boxSize="4" />
          </Center>
        </HStack>
        {errorTip && (
          <Text textStyle="caption" color="brand.error">
            {errorTip}
          </Text>
        )}
      </Box>
    </>
  );
};
